import AppHeader from "@saleor/components/AppHeader";
import CardSpacer from "@saleor/components/CardSpacer";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import Container from "@saleor/components/Container";
import Grid from "@saleor/components/Grid";
import Metadata from "@saleor/components/Metadata";
import PageHeader from "@saleor/components/PageHeader";
import SaveButtonBar from "@saleor/components/SaveButtonBar";
import { ProductErrorWithAttributesFragment } from "@saleor/fragments/types/ProductErrorWithAttributesFragment";
import useStateFromProps from "@saleor/hooks/useStateFromProps";
import { ExtraChargeCategoryData } from "@saleor/products/types/ExtraChargeCategoryData";
import { GetErpProductVariant_erpProductVariant } from "@saleor/products/types/GetErpProductVariant";
// import { getChoices } from "@saleor/products/utils/data";
import { SearchCornermarks_search_edges_node } from "@saleor/searches/types/SearchCornermarks";
import { SearchWarehouses_search_edges_node } from "@saleor/searches/types/SearchWarehouses";
import { ReorderAction } from "@saleor/types";
import React, { Dispatch, SetStateAction, useState } from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../../misc";
import { FetchMoreProps } from "../../../types";
import { ProductVariantCreateData_product } from "../../types/ProductVariantCreateData";
import ProductShipping from "../ProductShipping/ProductShipping";
import ProductStocks from "../ProductStocks";
import ProductVariantAttributes from "../ProductVariantAttributes";
import ProductVariantCornermarks from "../ProductVariantCornermarks";
import ProductVariantGetErp from "../ProductVariantGetErp";
import ProductVariantNavigation from "../ProductVariantNavigation";
import ProductVariantPrice from "../ProductVariantPrice";
import ProductVariantCreateForm, { ProductVariantCreateData } from "./form";
// import { ProductVariantCreateFormData } from "./form";

interface ProductVariantCreatePageProps {
  // 配镜方案下拉框
  setNewSku?: Dispatch<SetStateAction<string>>;
  extraChargeCategoryData?: ExtraChargeCategoryData;
  extraChargeCategory?: string;
  setExtraChargeCategory?: Dispatch<SetStateAction<string>>;
  // end
  currencySymbol: string;
  disabled: boolean;
  cornermarks?: SearchCornermarks_search_edges_node[];
  errors: ProductErrorWithAttributesFragment[];
  fetchCornermarks?: (data: string) => void;
  fetchMoreCornermarks?: FetchMoreProps;
  // initial?: Partial<ProductVariantCreateFormData>;
  header: string;
  product: ProductVariantCreateData_product;
  saveButtonBarState: ConfirmButtonTransitionState;
  warehouses: SearchWarehouses_search_edges_node[];
  weightUnit: string;
  onBack: () => void;
  onSubmit: (data: ProductVariantCreateData) => void;
  onVariantClick: (variantId: string) => void;
  onVariantReorder: ReorderAction;
  onWarehouseConfigure: () => void;
  onGetErpData: (erpSku: string) => void;
  erpProductVariant: GetErpProductVariant_erpProductVariant;
}

const ProductVariantCreatePage: React.FC<ProductVariantCreatePageProps> = ({
  // 配镜方案下拉框
  setNewSku,
  extraChargeCategoryData,
  extraChargeCategory,
  setExtraChargeCategory,
  // end
  currencySymbol,
  disabled,
  cornermarks: cornermarkChoiceList,
  errors,
  fetchCornermarks,
  fetchMoreCornermarks,
  // initial,
  header,
  product,
  saveButtonBarState,
  warehouses,
  weightUnit,
  onBack,
  onSubmit,
  onVariantClick,
  onVariantReorder,
  onWarehouseConfigure,
  onGetErpData,
  erpProductVariant
}) => {
  const intl = useIntl();

  const [selectedCornermark, setSelectedCornermark] = useStateFromProps("");

  const cornermarks = maybe(() => cornermarkChoiceList, []).map(cornermark => ({
    label: cornermark.titleText,
    value: cornermark
  }));
  // const [extraChargeCategoryOpts, setExtraChargeCategoryOpts] = useState<
  //   string[]
  // >(extraChargeCategoryData?.extraChargeCategory||[]);
  // useEffect(() => {
  //   setExtraChargeCategoryOpts(extraChargeCategoryData?.extraChargeCategory);
  // }, [extraChargeCategoryData]);
  const [extraChargeCategoryOpts] = useState<string[]>(
    extraChargeCategoryData?.extraChargeCategory || []
  );
  return (
    <ProductVariantCreateForm
      // initial={initial}
      product={product}
      onSubmit={onSubmit}
      warehouses={warehouses}
      cornermarks={cornermarks}
      setSelectedCornermark={setSelectedCornermark}
      setSelectedExtracharge={setExtraChargeCategory}
      erpProductVariant={erpProductVariant}
    >
      {({ change, data, handlers, hasChanged, submit }) => (
        <Container>
          <AppHeader onBack={onBack}>{product?.name}</AppHeader>
          <PageHeader title={header} />
          <Grid variant="inverted">
            <div>
              <ProductVariantNavigation
                fallbackThumbnail={product?.thumbnail?.url}
                variants={product?.variants}
                onRowClick={(variantId: string) => {
                  if (product && product.variants) {
                    return onVariantClick(variantId);
                  }
                }}
                onReorder={onVariantReorder}
              />
              <ProductVariantCornermarks
                cornermarks={cornermarks}
                cornermarkInputDisplayValue={selectedCornermark}
                data={data}
                disabled={disabled}
                errors={errors}
                fetchCornermarks={fetchCornermarks}
                fetchMoreCornermarks={fetchMoreCornermarks}
                onCornermarkChange={handlers.selectCornermark}
              />
              {/* <ProductVariantExtracharges/> */}
            </div>
            <div>
              <ProductVariantGetErp
                sku={data?.sku}
                disabled={disabled}
                errors={errors}
                onChange={change}
                onGetErpData={onGetErpData}
              />
              <CardSpacer />
              <ProductVariantAttributes
                attributes={data.attributes}
                disabled={disabled}
                errors={errors}
                onChange={handlers.selectAttribute}
              />
              <CardSpacer />
              <ProductVariantPrice
                data={data}
                errors={errors}
                currencySymbol={currencySymbol}
                loading={disabled}
                onChange={change}
              />
              <CardSpacer />

              <CardSpacer />
              <ProductShipping
                data={data}
                disabled={disabled}
                errors={errors}
                weightUnit={weightUnit}
                onChange={change}
              />
              <CardSpacer />
              <ProductStocks
                data={data}
                disabled={disabled}
                hasVariants={true}
                onFormDataChange={change}
                errors={errors}
                stocks={data.stocks}
                warehouses={warehouses}
                onChange={handlers.changeStock}
                onWarehouseStockAdd={handlers.addStock}
                onWarehouseStockDelete={handlers.deleteStock}
                onWarehouseConfigure={onWarehouseConfigure}
                // 配镜方案下拉框
                setNewSku={setNewSku}
                extraChargeCategoryOpts={extraChargeCategoryOpts}
                extraChargeCategory={extraChargeCategory}
                setExtraChargeCategory={setExtraChargeCategory}
                onExtrachargeChange={handlers.selectExtracharge}
                // end
              />
              <CardSpacer />
              <Metadata data={data} onChange={handlers.changeMetadata} />
            </div>
          </Grid>
          <SaveButtonBar
            disabled={disabled || !onSubmit || !hasChanged}
            labels={{
              delete: intl.formatMessage({
                defaultMessage: "Delete Variant",
                description: "button"
              }),
              save: intl.formatMessage({
                defaultMessage: "Save variant",
                description: "button"
              })
            }}
            state={saveButtonBarState}
            onCancel={onBack}
            onSave={submit}
          />
        </Container>
      )}
    </ProductVariantCreateForm>
  );
};
ProductVariantCreatePage.displayName = "ProductVariantCreatePage";
export default ProductVariantCreatePage;
